// extracted by mini-css-extract-plugin
module.exports = {"section":"cta_section__aZaAI","panel":"cta_panel__uu0uM","dividers":"cta_dividers__weDRt"};